import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from 'lodash'

import ReportContainer from "../ReportContainer";
import BadgingContent from "./BadgingContent";

import "./index.scss";

import { fetchBadges } from "../../../../services/badging/fetchBadges/fetchBadges";
import { generateBadgingReport } from "../../util/generators/generateBadgingReport";
import { BADGE_TYPE } from "../../../../services/badging/constants";
import SRS from "../../../../services/StudentRecordService";
import moment from "moment";

export default function BadgingReport(props) {

  const [status, setStatus] = useState(null);
  const [apiData, setApiData] = useState(null);

  const roster = useSelector(state => state.reports.roster);
  const rosterStatus = get(roster, 'status.type')
  const classId = get(roster, 'ui.selections.classroom.id')

  const usageWindow = useSelector(state => state.reports?.teacher?.usageWindow)
  const usageWindowId = usageWindow.value;

  const badgingLocale = useSelector(state => state.reports?.teacher?.badgingLocale)

  useEffect(() => {
    fetchBadgingReport();
  }, [rosterStatus, usageWindowId])

  const reportData = apiData ? generateBadgingReport(apiData.badgeData, roster.data.student, apiData.metrics, usageWindow, badgingLocale) : [];

  return (
    <ReportContainer>
      <div className="badgingReport">
        <BadgingContent 
          reportData={reportData} 
          fetchReport={fetchBadgingReport}
          status={status} 
          history={props.history} 
          usageWindow={usageWindow}
          badgingLocale={badgingLocale}
        />
      </div>
    </ReportContainer>
  );
  
  async function fetchBadgingReport(params={}) {
    const {skipLoading} = params;
    if (rosterStatus !== 'COMPLETE') return;
    if (!roster.data || !roster.data.student) return;
    const {startDate, endDate, value: usageWindowId} = usageWindow;
    const students = roster.data.student;
    const studentIds = students.map(student => student.id);
    if (!skipLoading) setStatus('PENDING');
    try {
      // concurrently fetch...
      // 1. badge data
      // 2. student metrics (skip if usage window is School Year)
      const dateStart = moment(startDate).format('YYYY-MM-DD');
      const dateEnd = moment(endDate).format('YYYY-MM-DD');
      const requests = [fetchBadges(studentIds), usageWindowId !== "school_year" && SRS.getStudentMetrics(studentIds, dateStart, dateEnd)];
      const response = await Promise.all(requests);
      let badgeData = response[0];
      const metrics = response[1];

      // filter out custom badges created for another class
      badgeData = badgeData.filter(badge => badge.badgeTypeId !== BADGE_TYPE.CUSTOM || badge.classId == classId);
      setApiData({badgeData, metrics})
      setStatus('DONE');
    } catch (e) {
      console.error(e);
      setStatus('ERROR');
    }
  }
}

